<div class="listcontainer">
    <div class="left">
        <div class="header" [title]="applicationText">
          <span class="application-text">{{applicationText}}</span>  
        </div>
        <edx-filelist-sidebar #appsListSideBar [receiver]="this" [list]="appIdList" [selectIndex]="currentAppIdIndex" [desc]="desc" [disabled]="disabledNav" [tabIndex]="0" [schemaId]="schemaId"></edx-filelist-sidebar>
    </div>
    <div class="right">
        <edx-list-table #groupProfileDefaultsTable [schemaId]="schemaId" [parent]="this" [desc]="desc" [inlineActionMenuId]="6" [inlineActionTarget]="this" [appFormSelections]="selections"></edx-list-table>
    </div>
</div>